export default __webpack_public_path__ + "static/media/19.6f27daf4.jpg";